var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.83 2.829 0l9.175 9.339L21.171 0 24 2.83 12.004 15 0 2.83Z"
  })));
};
export default SvgChevronDown;